'use strict';

exports.__esModule = true;
exports.ReviewBreakdown = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reviewBreakdown = require('../../src/styles/review-breakdown.scss');

var _reviewBreakdown2 = _interopRequireDefault(_reviewBreakdown);

var _breakdownRow = require('../../../breakdown-row');

var _utils = require('../utils/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReviewBreakdown = exports.ReviewBreakdown = function ReviewBreakdown(props) {
  var reviewsCount = props.reviewsCount,
      fiveStarsCount = props.fiveStarsCount,
      fourStarsCount = props.fourStarsCount,
      threeStarsCount = props.threeStarsCount,
      twoStarsCount = props.twoStarsCount,
      oneStarCount = props.oneStarCount;


  return _react2.default.createElement(
    'div',
    { className: '' + _reviewBreakdown2.default['review-breakdown'] },
    _react2.default.createElement(
      'h2',
      { className: '' + _reviewBreakdown2.default['review-breakdown__title'] },
      'Review Breakdown'
    ),
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_breakdownRow.BreakdownRow, {
        title: '5 Stars',
        filledRowWidth: (0, _utils.getValueForProgressBar)(reviewsCount, fiveStarsCount),
        reviewsCount: fiveStarsCount
      }),
      _react2.default.createElement(_breakdownRow.BreakdownRow, {
        title: '4 Stars',
        filledRowWidth: (0, _utils.getValueForProgressBar)(reviewsCount, fourStarsCount),
        reviewsCount: fourStarsCount
      }),
      _react2.default.createElement(_breakdownRow.BreakdownRow, {
        title: '3 Stars',
        filledRowWidth: (0, _utils.getValueForProgressBar)(reviewsCount, threeStarsCount),
        reviewsCount: threeStarsCount
      }),
      _react2.default.createElement(_breakdownRow.BreakdownRow, {
        title: '2 Stars',
        filledRowWidth: (0, _utils.getValueForProgressBar)(reviewsCount, twoStarsCount),
        reviewsCount: twoStarsCount
      }),
      _react2.default.createElement(_breakdownRow.BreakdownRow, {
        title: '1 Star',
        filledRowWidth: (0, _utils.getValueForProgressBar)(reviewsCount, oneStarCount),
        reviewsCount: oneStarCount
      })
    )
  );
};

ReviewBreakdown.displayName = 'ReviewBreakdown';

ReviewBreakdown.defaultProps = {
  reviewsCount: [],
  fiveStarsCount: 0,
  fourStarsCount: 0,
  threeStarsCount: 0,
  twoStarsCount: 0,
  oneStarCount: 0
};

ReviewBreakdown.propTypes = {
  reviewsCount: _propTypes2.default.array,
  fiveStarsCount: _propTypes2.default.number,
  fourStarsCount: _propTypes2.default.number,
  threeStarsCount: _propTypes2.default.number,
  twoStarsCount: _propTypes2.default.number,
  oneStarCount: _propTypes2.default.number
};

exports.default = ReviewBreakdown;


// WEBPACK FOOTER //
// ./components/profile-right-section/lib/components/review-breakdown.js